import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sectionSelectList: [],
    buildSelectList: [],
    projectSiteSelectList: [],
    treeNode: sessionStorage.getItem('treeNode') || {},
    usercname: sessionStorage.getItem('usercname') || '',
    permission: sessionStorage.getItem('permission') || '',

    userId: sessionStorage.getItem('userId') || '',
    userRole: sessionStorage.getItem('userRole') || '',
    userAccount: sessionStorage.getItem('userAccount') || '',
    userPermission: sessionStorage.getItem('userPermission') || '',
    periodOfValidity: '2027-7-2',
    resumeFileUpliadStatus: 1,
  },
  mutations: {
    setUserId(state, val) {
      state.userId = val
    },
    setUserRole(state, val) {
      state.userRole = val
    },
    setUserAccount(state, val) {
      state.userAccount = val
    },
    setUserPermission(state, val) {
      state.userPermission = val
    },
    setSectionSelectList(state, val) {
      state.sectionSelectList = val
    },

    setBuildSelectList(state, val) {
      state.buildSelectList = val
    },

    setProjectSiteSelectList(state, val) {
      state.projectSiteSelectList = val
    },
    setUsercname(state, val) {
      state.usercname = val
    },
    setTreeNode(state, val) {
      state.treeNode = val
    },
    setPermission(state, val) {
      state.permission = val
    },
    setSectionType(state, val) {
      state.sectionType = val
    },
    setResumeFileUpliadStatus(state, val) {
      state.resumeFileUpliadStatus = val
    }
  },
  actions: {},
  modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js